"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const request = (state, _, initState) => (Object.assign(Object.assign({}, state), { model: Object.assign(Object.assign({}, initState.model), { isLoading: true }) }));
const updateRequest = (state) => (Object.assign(Object.assign({}, state), { model: Object.assign(Object.assign({}, state.model), { isLoading: true }) }));
const success = (state, action, initState) => (Object.assign(Object.assign({}, state), { model: Object.assign(Object.assign({}, initState.model), { data: action.payload, isLoading: false }) }));
const deleteSuccess = (state, _, initState) => (Object.assign(Object.assign({}, state), { model: Object.assign(Object.assign({}, initState.model), { isLoading: false }) }));
const fail = (state) => (Object.assign(Object.assign({}, state), { model: Object.assign(Object.assign({}, state.model), { isLoading: false }) }));
const listRequest = (state) => (Object.assign(Object.assign({}, state), { list: Object.assign(Object.assign({}, state.list), { isFetchLoading: true }) }));
const listSuccess = (state, action) => (Object.assign(Object.assign({}, state), { list: Object.assign(Object.assign({}, state.list), { data: action.payload, isFetchLoading: false }) }));
const listFail = (state) => (Object.assign(Object.assign({}, state), { list: Object.assign(Object.assign({}, state.list), { isFetchLoading: false }) }));
const countRequest = (state) => (Object.assign(Object.assign({}, state), { list: Object.assign(Object.assign({}, state.list), { isCountLoading: true }) }));
const countSuccess = (state, action) => (Object.assign(Object.assign({}, state), { list: Object.assign(Object.assign(Object.assign({}, state.list), action.payload), { isCountLoading: false }) }));
const countFail = (state) => (Object.assign(Object.assign({}, state), { list: Object.assign(Object.assign({}, state.list), { isCountLoading: false }) }));
const clean = (_, __, initState) => initState;
exports.createReducer = (handlers, initialState) => (state = initialState, action) => {
    const debug = debug_1.default('createReducer');
    const handler = handlers[action.type];
    if (!handler)
        return state;
    const nextState = handler(state, action, initialState);
    debug(`${action.type} nextState`, nextState);
    return Object.assign(Object.assign({}, state), nextState);
};
exports.createInitState = (data) => ({
    list: {
        isFetchLoading: false,
        isCountLoading: false,
        count: 0,
        data: [],
    },
    model: {
        data,
        isLoading: false,
    },
});
exports.reducerCreator = (name, initialState) => {
    const handlers = {
        [`@${name}:CREATE_REQUEST`]: request,
        [`@${name}:FETCH_REQUEST`]: request,
        [`@${name}:DELETE_REQUEST`]: request,
        [`@${name}:UPDATE_REQUEST`]: updateRequest,
        [`@${name}:CREATE_SUCCESS`]: success,
        [`@${name}:FETCH_SUCCESS`]: success,
        [`@${name}:UPDATE_SUCCESS`]: success,
        [`@${name}:DELETE_SUCCESS`]: deleteSuccess,
        [`@${name}:CREATE_FAIL`]: fail,
        [`@${name}:FETCH_FAIL`]: fail,
        [`@${name}:DELETE_FAIL`]: fail,
        [`@${name}:UPDATE_FAIL`]: fail,
        [`@${name}:LIST_REQUEST`]: listRequest,
        [`@${name}:LIST_SUCCESS`]: listSuccess,
        [`@${name}:LIST_FAIL`]: listFail,
        [`@${name}:COUNT_REQUEST`]: countRequest,
        [`@${name}:COUNT_SUCCESS`]: countSuccess,
        [`@${name}:COUNT_FAIL`]: countFail,
        [`@${name}:CLEAN`]: clean,
    };
    return {
        getReducer: () => exports.createReducer(handlers, exports.createInitState(initialState)),
        getHandlers: () => handlers,
    };
};
//# sourceMappingURL=ReducerCreator.js.map